import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { isNotNull, isNotObject } from '@satin/core/utility';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class ValidationService {
    static getErrorMessage(validatorName, validatorValue) {
        const config = {
            'required': 'This Field is Required',
            'minlength': `This Field has a Minimum length of ${validatorValue.requiredLength}`,
            'maxlength': `This Field has a Maximum length of ${validatorValue.requiredLength}`,
            'max': `This Field has a Maximum value of ${validatorValue.max}`,
            'min': `This Field has a Minimum value of ${validatorValue.min}`,
            'phoneNumber': `This Field is not a valid Phone Number`,
            'requireMatch': `Please select an option from the list`,
            'email': `This Field is not a valid Email Address`,
            'invalidGmEmail': `Please enter a valid GM email address`,
            'whitespace': `Whitespace entries are not allowed`
        };
        return config[validatorName];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ValidationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ValidationService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ValidationService, decorators: [{
            type: Injectable
        }] });
function ValidatePhoneNumber(control) {
    // RFC 2822 compliant regex
    if (isNotNull(control) && isNotNull(control.value)) {
        if (!control.value.match('((\\+[0-9]{1,5}\\s{0,}){0,1}(\\([0-9]{3,}\\)){0,1}\\s{0,}([0-9]{3,}[-|\\s]{0,1})' +
            '{1,2}[0-9]{4,})\\s{0,}([E|e][X|x][T|t]\\s{0,}[0-9]{1,15}){0,1}|[0-9]{7,20}|[N|n]\\/{0,1}[A|a]')) {
            return { 'phoneNumber': true };
        }
    }
    return null;
}
function ValidateEmail(control) {
    const EMAIL_REGEXP = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;
    if (isNotNull(control) && isNotNull(control.value)) {
        if (!control.value.match(EMAIL_REGEXP)) {
            return { 'email': true };
        }
    }
    return null;
}
function ValidateGmEmail(control) {
    const GM_EMAIL_REGEXP = /^[a-zA-Z0-9_.+-]+@(?:(?:[a-zA-Z0-9-]+\.)?[a-zA-Z]+\.)?(gm)\.com$/i;
    if (isNotNull(control) && isNotNull(control.value)) {
        if (!control.value.match(GM_EMAIL_REGEXP)) {
            return { 'invalidGmEmail': true };
        }
    }
    return null;
}
function AutocompleteValidator(control) {
    if (isNotNull(control.value)) {
        if (isNotObject(control.value)) {
            return { requireMatch: true };
        }
    }
    return null;
}
function NoWhitespaceValidator(control) {
    if (isNotNull(control.value)) {
        const isWhitespace = control.value.length > 0 && (control.value).trim().length === 0;
        if (isWhitespace) {
            return { 'whitespace': true };
        }
    }
    return null;
}

class ValidationMessageComponent {
    constructor() {
    }
    getErrorMessage() {
        if (isNotNull(this.control)) {
            for (const propertyName in this.control.errors) {
                if (this.control.errors.hasOwnProperty(propertyName) && this.control.touched) {
                    return ValidationService.getErrorMessage(propertyName, this.control.errors[propertyName]);
                }
            }
        }
        return null;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ValidationMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.10", type: ValidationMessageComponent, selector: "validation-message", inputs: { control: "control" }, ngImport: i0, template: `
        <span class='error-message' *ngIf="getErrorMessage() !== null">{{getErrorMessage()}}</span>`, isInline: true, styles: [".error-message{width:100%;font-size:80%;color:#dc3545}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ValidationMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'validation-message', template: `
        <span class='error-message' *ngIf="getErrorMessage() !== null">{{getErrorMessage()}}</span>`, styles: [".error-message{width:100%;font-size:80%;color:#dc3545}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { control: [{
                type: Input
            }] } });

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
class ValidationMessageModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ValidationMessageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.10", ngImport: i0, type: ValidationMessageModule, declarations: [ValidationMessageComponent], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule], exports: [ValidationMessageComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ValidationMessageModule, providers: [
            ValidationService
        ], imports: [CommonModule,
            FormsModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.10", ngImport: i0, type: ValidationMessageModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ValidationMessageComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule
                    ],
                    exports: [
                        ValidationMessageComponent
                    ],
                    providers: [
                        ValidationService
                    ]
                }]
        }] });

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AutocompleteValidator, NoWhitespaceValidator, ValidateEmail, ValidateGmEmail, ValidatePhoneNumber, ValidationMessageComponent, ValidationMessageModule, ValidationService };
